module.exports = __webpack_public_path__ + "fonts/rubik-medium-webfont.022dc10b.022dc10b.eot";